import { render, staticRenderFns } from "./SaleDetail.vue?vue&type=template&id=799cf1e1&scoped=true&"
import script from "./SaleDetail.vue?vue&type=script&lang=js&"
export * from "./SaleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799cf1e1",
  null
  
)

export default component.exports